import { render, staticRenderFns } from "./AddDialogAiHandwriting.vue?vue&type=template&id=4f54f754&scoped=true"
import script from "./AddDialogAiHandwriting.vue?vue&type=script&lang=js"
export * from "./AddDialogAiHandwriting.vue?vue&type=script&lang=js"
import style0 from "./AddDialogAiHandwriting.vue?vue&type=style&index=0&id=4f54f754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54f754",
  null
  
)

export default component.exports